// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BeCK0","newExpiryDate":"styles_newExpiryDate__3Vwdx","footer":"styles_footer__2jwYo"};